import React, { useState, useRef, useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Logout from "./components/Logout";
// import AuthTabs from "./components/AuthTabs";
import LoginForm from "./components/LoginForm";
import RegisterForm from "./components/RegisterForm";
import Dashboard from "./components/SportMentalTest/SportMentalTestScreen";
// import Header from "./components/Header";
import ChangePassword from "./components/ChangePassword";
import ForgotPassword from "./components/ForgotPassword";
import AdminLogin from "./components/AdminLogin";
import AdminDashboard from "./components/AdminDashboard";
import SubAdminDashboard from "./components/SubAdminDashboard";
import Profile from "./components/Profile";
import OrganizationManager from "./components/OrganizationManager";
import ManageUsers from "./components/ManageUsers";

import Toast from "./components/Toast";
import logoImage from "./resources/1000028180.jpeg";
// import { Button } from "tailwindcss";

import "./index.css";

// Import auth utilities

import {
  isLoggedIn,
  getUserType,
  getDashboardRoute,
  isSuperAdmin,
} from "./utils/auth";

// Import test screens
// import SportMentalTestsScreen from './components/SportMentalTest/SportMentalTestScreen';
import MTT20ChallengePage from "./components/SportMentalTest/MTT-20/MTT20ChallengePage";
import MTT20CommitmentPage from "./components/SportMentalTest/MTT-20/MTT20CommitmentPage";
import MTT20ControlPage from "./components/SportMentalTest/MTT-20/MTT20ControlPage";
import MTT20ConfidencePage from "./components/SportMentalTest/MTT-20/MTT20ConfidencePage";
import Cognitive from "./components/SportMentalTest/PAT-10/Cognitive";
import Somatic from "./components/SportMentalTest/PAT-10/Somatic";
import SelfConfidence from "./components/SportMentalTest/PAT-10/SelfConfidence";
import Handling from "./components/SportMentalTest/SMA U10/Handling";
import Focused from "./components/SportMentalTest/SMA U10/Focused";
import Confident from "./components/SportMentalTest/SMA U10/Confident";
import NervousFeeling from "./components/SportMentalTest/SMA U10/NervousFeeling";

// SMFT-30 Pages
import Resilience from "./components/SportMentalTest/SMFT-30/Resilience";
import Confidence from "./components/SportMentalTest/SMFT-30/Confidence";
import Adaptability from "./components/SportMentalTest/SMFT-30/Adaptability";
import Focus from "./components/SportMentalTest/SMFT-30/Focus";
import Motivation from "./components/SportMentalTest/SMFT-30/Motivation";
import PerformanceUnderPressure from "./components/SportMentalTest/SMFT-30/PerformancePressure";
import EmotionalControl from "./components/SportMentalTest/SMFT-30/EmotionalControl";
import Leadership from "./components/SportMentalTest/SMFT-30/Leadership";
import StressManagement from "./components/SportMentalTest/SMFT-30/StressManagement";
import AnxietyManagement from "./components/SportMentalTest/SMFT-30/AnxietyManagement";
import GoalSetting from "./components/SportMentalTest/SMFT-30/GoalSetting";
import SustainedFocus from "./components/SportMentalTest/SMFT-30/SustainedFocus";
import Positiveselftalk from "./components/SportMentalTest/SMFT-30/Positiveselftalk";
import ExternalPressure from "./components/SportMentalTest/SMFT-30/ExternalPressure";
import GameIntelligence from "./components/SportMentalTest/SMFT-30/GameIntelligence";
import TeamChemistry from "./components/SportMentalTest/SMFT-30/TeamChemistry";
import Drive from "./components/SportMentalTest/SMFT-30/Drive";
import TrainingFocus from "./components/SportMentalTest/SMFT-30/TrainingFocus";
import Sportsmanship from "./components/SportMentalTest/SMFT-30/Sportsmanship";
import MentalResilience from "./components/SportMentalTest/SMFT-30/MentalResilience";
import ExternalExpectations from "./components/SportMentalTest/SMFT-30/ExternalExpectations";
import Passion from "./components/SportMentalTest/SMFT-30/Passion";
import TestSummary from "./components/SportMentalTest/TestSummary";
import ReportViewer from "./components/SportMentalTest/Test Result/ReportViwer";
import GraphReport from "./components/GraphReport";
import SMFT30Arabic from "./components/SportMentalTest/SMFT-30/SMFT30Arabic";
import PAT10Arabic from "./components/SportMentalTest/PAT-10/PAT10Arabic";
import SMAU10Arabic from "./components/SportMentalTest/SMA U10/SMAU10Arabic";
import MTT20Arabic from "./components/SportMentalTest/MTT-20/MTT20Arabic";

// Public Route - prevents logged-in users from accessing login pages
function PublicRoute({ children }) {
  const userType = getUserType();

  if (userType === "admin") {
    return <Navigate to="/AdminDashboard" />;
  } else if (userType === "user") {
    return <Navigate to="/dashboard" />;
  }

  return children;
}

// Private Route - requires authentication
function PrivateRoute({ children, requiredUserType = null }) {
  const userType = getUserType();

  if (!userType) {
    return <Navigate to="/" />;
  }

  // If specific user type is required, check if user matches
  if (requiredUserType && userType !== requiredUserType) {
    // Redirect to appropriate dashboard based on user type
    return <Navigate to={getDashboardRoute()} />;
  }

  return children;
}

// Super Admin Route - requires super admin authentication
function SuperAdminRoute({ children }) {
  const userType = getUserType();

  if (!userType || userType !== "admin") {
    return <Navigate to="/" />;
  }

  if (!isSuperAdmin()) {
    return <Navigate to="/AdminDashboard" />;
  }

  return children;
}

export default function App() {
  const [loginMode, setLoginMode] = useState("user");
  const [showRegister, setShowRegister] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const menuRef = useRef();
  const [toast, setToast] = useState("");
  const [toastType, setToastType] = useState("info");

  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowMenu(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleMenuSelect = (mode) => {
    setLoginMode(mode);
    setShowMenu(false);
    setShowRegister(false);
  };

  const showToast = (message, type = "info") => {
    setToast(message);
    setToastType(type);
  };

  const handleToastClose = () => setToast("");

  return (
    <>
      {toast && (
        <Toast message={toast} type={toastType} onClose={handleToastClose} />
      )}
      <Routes>
        {/* Login Page - Public Route */}
        <Route
          path="/"
          element={
            <PublicRoute>
              <div className="min-h-screen flex flex-col lg:flex-row relative overflow-hidden px-2 sm:px-4" style={{paddingLeft: 8, paddingRight: 8}}>
                {/* Left Section - Information */}
                <div className="flex w-full lg:w-[calc(100vw-576px)] bg-white items-center justify-center px-2 sm:px-4 lg:px-12 mb-6 lg:mb-0">
                  <div className="max-w-lg">
                    <h1
                      className="text-4xl font-bold mb-8 "
                      style={{ display: "block", width: "100%", maxWidth: 700 }}
                    >
                      <span className="text-[rgba(75,75,75,1)]">
                        Welcome to{" "}
                      </span>
                      <span className="text-teal-600">Sport Mental Tests</span>
                    </h1>
                    <div className="space-y-4 text-[rgba(0,0,0,1) text-lg leading-relaxed">
                      <p>
                        Empower your mindset through self-reflection and
                        professional assessment. Our comprehensive mental
                        fitness tests are designed to help you understand and
                        improve your mental well-being in sports.
                      </p>
                      <p>
                        Whether you're an athlete, coach, or sports
                        professional, our platform provides valuable insights
                        into your mental strengths and areas for growth.
                      </p>
                      <p>
                        Take the first step towards mental excellence and
                        discover your true potential in sports performance.
                      </p>
                    </div>
                  </div>
                </div>
                {/* Right Section - Login Form */}
                <div
                  className="w-full lg:w-[576px] lg:h-screen lg:absolute lg:right-0 lg:top-0 bg-gradient-to-br from-[#2AA7A1] via-[#2AA7A1] to-[#E0F7F4] flex items-center justify-center"
                  style={{
                    background:
                      "linear-gradient(296.54deg, #2AA7A1 -25.98%, #E0F7F4 66.42%)",
                  }}
                >
                  {/* Form Card */}
                  <div
                    className={`bg-white rounded-2xl shadow-xl flex flex-col items-center justify-center${
                      showRegister ? " form-card-scroll" : ""
                    }`}
                    style={{
                      width: "100%",
                      maxWidth: 400,
                      margin: "0 auto",
                      padding: "24px 12px 32px 12px",
                      borderRadius: "16px",
                      boxShadow: "0px 8px 8px 0px rgba(0, 0, 0, 0.05)",
                      opacity: 1,
                      boxSizing: "border-box",
                    }}
                  >
                    {!showRegister && (
                      <div
                        className={`flex justify-center w-full`}
                        style={{
                          width: "100%",
                          gap: 0,
                          marginBottom: 16,
                        }}
                      >
                        <button
                          onClick={() => handleMenuSelect("user")}
                          className={`text-sm font-medium transition-all duration-200 shadow-sm ${
                            loginMode === "user"
                              ? "bg-teal-600 text-white"
                              : "text-gray-600 hover:text-gray-800"
                          } login-toggle-btn`}
                          style={{
                            width: "50%",
                            minWidth: 0,
                            padding: "12px 0",
                            borderTopLeftRadius: "8px",
                            borderBottomLeftRadius: "8px",
                            fontWeight: 600,
                            fontSize: 16,
                            borderTopRightRadius: "0px",
                            borderBottomRightRadius: "0px",
                            borderWidth: "1px",
                            background:
                              loginMode === "user"
                                ? "rgba(15, 150, 144, 1)"
                                : "rgba(255, 255, 255, 1)",
                            border: "1px solid rgba(15, 150, 144, 1)",
                            boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                          }}
                        >
                          User
                        </button>
                        <button
                          onClick={() => handleMenuSelect("admin")}
                          className={`text-sm font-medium transition-all duration-200 shadow-sm ${
                            loginMode === "admin"
                              ? "bg-teal-600 text-white"
                              : "text-gray-600 hover:text-gray-800"
                          } login-toggle-btn`}
                          style={{
                            width: "50%",
                            minWidth: 0,
                            padding: "12px 0",
                            borderTopRightRadius: "8px",
                            borderBottomRightRadius: "8px",
                            fontWeight: 600,
                            fontSize: 16,
                            borderTopLeftRadius: "0px",
                            borderBottomLeftRadius: "0px",
                            borderWidth: "1px",
                            background:
                              loginMode === "admin"
                                ? "rgba(15, 150, 144, 1)"
                                : "rgba(255, 255, 255, 1)",
                            border: "1px solid rgba(15, 150, 144, 1)",
                            boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                          }}
                        >
                          Admin
                        </button>
                      </div>
                    )}
                    {loginMode === "user" ? (
                      <div
                        className={`transition-all duration-300 w-full h-full flex flex-col ${
                          showRegister ? "opacity-100" : "opacity-100"
                        }`}
                      >
                        {showRegister ? (
                          <>
                            {/* <button
                              onClick={() => setShowRegister(false)}
                              className="mb-4 text-gray-500 hover:text-teal-600 font-medium transition-colors duration-200 flex items-center"
                              style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', alignSelf: 'flex-start' }}
                            >
                              &#8592; Back
                            </button> */}

                                                         <div className="flex flex-row ml-10">
                               <img
                                 src={logoImage}
                                 alt="Power Mind Metrics Logo"
                                 style={{ width: "60px", height: "50px", marginTop: "7px" }}
                               />
                               <div className="ml-5 mb-6">
                                 <h2
                                   style={{
                                     height: "36px",
                                     opacity: 1,
                                     fontWeight: 500,
                                     fontSize: "24px",
                                     lineHeight: "150%",
                                     letterSpacing: "0%",
                                     color: "rgba(75, 75, 75, 1)",
                                     margin: "0 auto",
                                   }}
                                 >
                                   Create Account
                                 </h2>
                                 <p
                                   style={{
                                     height: "24px",
                                     opacity: 1,
                                     fontWeight: 400,
                                     fontSize: "18px",
                                     lineHeight: "150%",
                                     letterSpacing: "0%",
                                     color: "rgba(75, 75, 75, 1)",
                                     marginBottom: "5px",
                                   }}
                                 >
                                   Join us and start your journey
                                 </p>
                               </div>
                             </div>
                            {/* <div className="p-10"/> */}
                            <RegisterForm showToast={showToast} />
                            <p
                              className="text-center mt-2 text-gray-600"
                              style={{
                                marginTop: "10px",
                                marginBottom: "14px",
                              }}
                            >
                              Already have an account?{" "}
                              <button
                                onClick={() => setShowRegister(false)}
                                className="text-teal-600 hover:text-teal-700 font-medium transition-colors duration-200"
                                style={{
                                  background: "none",
                                  border: "none",
                                  paddingBottom: "30px",
                                  cursor: "pointer",
                                }}
                              >
                                Sign In
                              </button>
                            </p>
                          </>
                        ) : (
                          <>
                                                         <div className="flex flex-row ml-10">
                               <img
                                 src={logoImage}
                                 alt="Power Mind Metrics Logo"
                                 style={{ width: "60px", height: "50px", marginTop: "7px" }}
                               />
                               <div className="ml-5 mb-6">
                                 <h2
                                   style={{
                                     height: "36px",
                                     opacity: 1,
                                     fontWeight: 500,
                                     fontSize: "24px",
                                     lineHeight: "150%",
                                     letterSpacing: "0%",
                                     color: "rgba(75, 75, 75, 1)",
                                     margin: "0 auto",
                                   }}
                                 >
                                   User Login
                                 </h2>
                                 <p
                                   style={{
                                     height: "24px",
                                     opacity: 1,
                                     fontWeight: 400,
                                     fontSize: "18px",
                                     lineHeight: "150%",
                                     letterSpacing: "0%",
                                     color: "rgba(75, 75, 75, 1)",
                                     marginBottom: "5px",
                                   }}
                                 >
                                   Sign in to your account
                                 </p>
                               </div>
                             </div>
                            {/* <div className="flex-1" style={{
                                  width: '402px',
                                  height: '188px',
                                  opacity: 1,
                                  display: 'flex',
                                  flexDirection: 'column',
                                  gap: '24px'
                                }}> */}
                            <LoginForm showToast={showToast} />
                            {/* </div> */}
                            <p
                              className="text-center mb-8 text-gray-600"
                              // style={{ marginBottom: "2px" }}
                            >
                              Don't have an account?{" "}
                              <a
                                onClick={() => setShowRegister(true)}
                                className="text-sky-400 hover:text-blue-700 font-medium transition-colors duration-200 cursor-pointer"
                              >
                                Register here
                              </a>
                            </p>
                          </>
                        )}
                      </div>
                    ) : (
                      <div className="w-full h-full flex flex-col">
                        <div className="flex flex-row ml-10">
                          <img
                            src={logoImage}
                            alt="Power Mind Metrics Logo"
                            style={{ width: "60px", height: "50px", marginTop: "7px" }}
                          />
                          <div className="ml-5 mb-6">
                            <h2
                              className="text-2xl font-bold text-gray-800 mb-4"
                              style={{
                                // width: "402px",
                                height: "36px",
                                opacity: 1,
                                // fontFamily: 'Poppins',
                                fontWeight: 500,
                                // fontStyle: 'poppins',
                                fontSize: "24px",
                                lineHeight: "150%",
                                letterSpacing: "0%",
                                // textAlign: "center",
                                color: "rgba(75, 75, 75, 1)",
                                margin: "0 auto",
                                // marginRight: "90px",
                              }}
                            >
                              Admin Login
                            </h2>
                            <p
                              className="text-gray-600"
                              style={{
                                // width: "402px",
                                height: "24px",
                                opacity: 1,
                                // fontFamily: 'Poppins',
                                fontWeight: 400,
                                // fontStyle: 'normal',
                                fontSize: "18px",
                                lineHeight: "150%",
                                letterSpacing: "0%",
                                // textAlign: "center",
                                color: "rgba(75, 75, 75, 1)",
                                // margin: "5px 0px",
                                // marginLeft: "10px",
                                // marginTop: "5px",
                                marginBottom: "5px",
                                // marginRight: "90px",
                              }}
                            >
                              Access the admin dashboard
                            </p>
                          </div>
                        </div>
                        <div className="flex-1">
                          <AdminLogin showToast={showToast} />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Footer */}
              <div
                style={{
                  position: "fixed",
                  bottom: 0,
                  left: 0,
                  right: 0,
                  background: "rgba(255, 255, 255, 0.95)",
                  backdropFilter: "blur(10px)",
                  borderTop: "1px solid rgba(0, 0, 0, 0.1)",
                  padding: "12px 0",
                  textAlign: "center",
                  fontFamily: "Poppins, sans-serif",
                  zIndex: 100,
                }}
              >
                <p
                  style={{
                    margin: 0,
                    fontSize: "14px",
                    color: "rgba(75, 75, 75, 0.8)",
                    fontWeight: 400,
                  }}
                >
                  © 2025 All rights reserved Power Mind Metrics
                </p>
              </div>
            </PublicRoute>
          }
        />

        {/* User Dashboard Route */}
        <Route
          path="/dashboard"
          element={
            <PrivateRoute requiredUserType="user">
              <Dashboard />
            </PrivateRoute>
          }
        />

        {/* Admin Dashboard Route */}
        <Route
          path="/AdminDashboard"
          element={
            <PrivateRoute requiredUserType="admin">
              <AdminDashboard />
            </PrivateRoute>
          }
        />



        {/* Sub-Admin Dashboard Route */}
        <Route
          path="/admin/sub-admins"
          element={
            <SuperAdminRoute>
              <SubAdminDashboard />
            </SuperAdminRoute>
          }
        />

        {/* Profile Route - accessible by both user types */}
        <Route
          path="/profile"
          element={
            <PrivateRoute>
              <Profile />
            </PrivateRoute>
          }
        />

        {/* Other Routes */}
        <Route path="/logout" element={<Logout showToast={showToast} />} />
        <Route path="/change-password" element={<ChangePassword />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route
          path="/admin-login"
          element={
            <PublicRoute>
              <AdminLogin />
            </PublicRoute>
          }
        />
        <Route path="/test-summary" element={<TestSummary />} />

        {/* MTT-20 */}
        <Route path="/MTT20ChallengePage" element={<MTT20ChallengePage />} />
        <Route path="/MTT20CommitmentPage" element={<MTT20CommitmentPage />} />
        <Route path="/MTT20ControlPage" element={<MTT20ControlPage />} />
        <Route path="/MTT20ConfidencePage" element={<MTT20ConfidencePage />} />

        {/* PAT-10 */}
        <Route path="/Cognitive" element={<Cognitive />} />
        <Route path="/Somatic" element={<Somatic />} />
        <Route path="/SelfConfidence" element={<SelfConfidence />} />

        {/* SMA U10 */}
        <Route path="/Handling" element={<Handling />} />
        <Route path="/Focused" element={<Focused />} />
        <Route path="/Confident" element={<Confident />} />
        <Route path="/NervousFeeling" element={<NervousFeeling />} />

        {/* SMFT-30 */}
        <Route path="/Resilience" element={<Resilience />} />
        <Route path="/Confidence" element={<Confidence />} />
        <Route path="/Adaptability" element={<Adaptability />} />
        <Route path="/Focus" element={<Focus />} />
        <Route path="/Motivation" element={<Motivation />} />
        <Route
          path="/PerformanceUnderPressure"
          element={<PerformanceUnderPressure />}
        />
        <Route path="/EmotionalControl" element={<EmotionalControl />} />
        <Route path="/Leadership" element={<Leadership />} />
        <Route path="/StressManagement" element={<StressManagement />} />
        <Route path="/AnxietyManagement" element={<AnxietyManagement />} />
        <Route path="/GoalSetting" element={<GoalSetting />} />
        <Route path="/SustainedFocus" element={<SustainedFocus />} />
        <Route path="/Positiveselftalk" element={<Positiveselftalk />} />
        <Route path="/ExternalPressure" element={<ExternalPressure />} />
        <Route path="/GameIntelligence" element={<GameIntelligence />} />
        <Route path="/TeamChemistry" element={<TeamChemistry />} />
        <Route path="/Drive" element={<Drive />} />
        <Route path="/TrainingFocus" element={<TrainingFocus />} />
        <Route path="/Sportsmanship" element={<Sportsmanship />} />
        <Route path="/MentalResilience" element={<MentalResilience />} />
        <Route
          path="/ExternalExpectations"
          element={<ExternalExpectations />}
        />
        <Route path="/Passion" element={<Passion />} />
        <Route path="/report" element={<ReportViewer />} />
        <Route path="/smft-arabic" element={<SMFT30Arabic />} />
        <Route path="/pat-arabic" element={<PAT10Arabic />} />
        <Route path="/sma-arabic" element={<SMAU10Arabic />} />
        <Route path="/mtt-arabic" element={<MTT20Arabic />} />

        {/* Graph Report Route */}
        <Route
          path="/graph-report"
          element={
            <PrivateRoute>
              <GraphReport />
            </PrivateRoute>
          }
        />

        {/* Organization Manager Route (admin only) */}
        <Route
          path="/organizations"
          element={
            <PrivateRoute requiredUserType="admin">
              <OrganizationManager />
            </PrivateRoute>
          }
        />

        {/* Manage Users Route (admin only) */}
        <Route
          path="/manage-users"
          element={
            <PrivateRoute requiredUserType="admin">
              <ManageUsers />
            </PrivateRoute>
          }
        />

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </>
  );
}
